// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { AlertTriangle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconAlertTriangle(props: any) {
    return <IconBase icon={AlertTriangle} {...props} />
  }

  export default IconAlertTriangle
  